module finadai.app.agents.list {
  export var NAME = "finadai.app.agents.list";
  function AgentsListController($scope, $q: ng.IQService, agentsService: finadai.services.AgentsService, notify, $http: ng.IHttpService, $state: ng.ui.IStateService) {

    $scope.selected = [];
    $scope.limitOptions = [5, 10, 15];

    $scope.options = {
      rowSelection: true,
      multiSelect: true,
      autoSelect: true,
      decapitate: false,
      largeEditDialog: false,
      boundaryLinks: false,
      limitSelect: true,
      pageSelect: true
    };

    $scope.query = {
      order: '-updated_at._date',
      limit: 10,
      page: 1
    };

    $scope.toggleLimitOptions = function () {
      $scope.limitOptions = $scope.limitOptions ? undefined : [5, 10, 15];
    };

    $scope.reload = () => {
      $scope.promise = agentsService.get().then(response => {
        $scope.agents = response.data;
        return response;
      });
    }
    $scope.reload();
    $scope.remove = id => {
      $q.all($scope.selected.map(item => agentsService.remove(item.id))).then(responses => {
        $scope.selected = [];
        notify('Registro(s) eliminado(s)')
        $scope.reload();
      })
    }
    $scope.edit = e => {
      $state.go('app.agents.detail', {agentId: $scope.selected[0].id});
    }
  }
  export function run() {
    var list = angular.module(NAME, []);
    list.controller('AgentsListController', AgentsListController);
  }
}
finadai.app.agents.list.run();